import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import FacetPlanCustomStrategySetupContributionLimitAssumption
  from 'Views/Page/Content/Modal/Layouts/FacetPlanCustomStrategySetupInfoStep/Components/Assumptions/FacetPlanCustomStrategySetupContributionLimitAssumption';
import FacetPlanCustomStrategySetupAddableForm
  from 'Views/Page/Content/Modal/Layouts/FacetPlanCustomStrategySetupInfoStep/Components/AddableForm/FacetPlanCustomStrategySetupAddableForm';
import WithdrawalLayout
  from 'Views/Page/Content/Modal/Layouts/FacetPlanCustomStrategySetupInfoStep/Components/AddableForm/WithdrawalLayout';
import ExpenseLayout
  from 'Views/Page/Content/Modal/Layouts/FacetPlanCustomStrategySetupInfoStep/Components/AddableForm/ExpenseLayout';
import IncomeLayout
  from 'Views/Page/Content/Modal/Layouts/FacetPlanCustomStrategySetupInfoStep/Components/AddableForm/IncomeLayout';
import EmployerMatchLayout
  from 'Views/Page/Content/Modal/Layouts/FacetPlanCustomStrategySetupInfoStep/Components/EmployerMatch/Layout';
import AssumptionLayout
  from 'Views/Page/Content/Modal/Layouts/FacetPlanCustomStrategySetupInfoStep/Components/Assumptions/AssumptionLayout';
import CatchUpAssumptionLayout
  from 'Views/Page/Content/Modal/Layouts/FacetPlanCustomStrategySetupInfoStep/Components/Assumptions/CatchUpAssumptionLayout';
import FacetPlanCustomStrategySetupCatchUpAssumption
  from 'Views/Page/Content/Modal/Layouts/FacetPlanCustomStrategySetupInfoStep/Components/Assumptions/FacetPlanCustomStrategySetupCatchUpContributionLimitAssumption';

const metaOverrideSet = buildFacetDesignOverride()
  .override({ hint: 'usd' }, {
    _customProps: {
      fullWidth: true,
    },
  }, overrideReadOnly)
  .override({ hint: 'percent' }, {
    _customProps: {
      fullWidth: true,
    },
  }, overrideReadOnly)
  .nameOverride('contributionLimits', {
    _component: () => FacetPlanCustomStrategySetupContributionLimitAssumption,
    _customProps: { attrName: 'contributionLimits', resourceLayout: () => AssumptionLayout },
  }, overrideReadOnly)
  .nameOverride('catchUpContributionLimits', {
    _component: () => FacetPlanCustomStrategySetupCatchUpAssumption,
    _customProps: { attrName: 'catchUpContributionLimits', resourceLayout: () => CatchUpAssumptionLayout },
  }, overrideReadOnly)
  .nameOverride('employerMatchContributionLimits', {
    _component: () => FacetPlanCustomStrategySetupContributionLimitAssumption,
    _customProps: { attrName: 'employerMatchContributionLimits', label: 'Employer Contribution Limits', resourceLayout: () => AssumptionLayout },
  }, overrideReadOnly)
  .nameOverride('fixedWithdrawals', {
    _component: () => FacetPlanCustomStrategySetupAddableForm,
    _customProps: { attrName: 'fixedWithdrawals', resourceLayout: () => WithdrawalLayout },
  }, overrideReadOnly)
  .nameOverride('generatedIncome', {
    _component: () => FacetPlanCustomStrategySetupAddableForm,
    _customProps: { attrName: 'generatedIncome', resourceLayout: () => IncomeLayout },
  }, overrideReadOnly)
  .nameOverride('generatedExpenses', {
    _component: () => FacetPlanCustomStrategySetupAddableForm,
    _customProps: { attrName: 'generatedExpenses', resourceLayout: () => ExpenseLayout },
  }, overrideReadOnly)
  .nameOverride('electiveEmployerMatchingRules', {
    _component: () => EmployerMatchLayout,
  }, overrideReadOnly);


export default metaOverrideSet;
